import resourcesToBackend from "i18next-resources-to-backend";
import { i18next, i18nDefaultOptions, i18nLangDetectionConfig } from "@sundae/i18n-config";
export const languages = [
    {
        locale: "ar",
        localeString: "عربي",
    },
    {
        locale: "de",
        localeString: "Deutsch",
    },
    {
        locale: "en",
        localeString: "English",
    },
    {
        locale: "es",
        localeString: "Español",
    },
    {
        locale: "fr",
        localeString: "Français",
    },
    {
        locale: "it",
        localeString: "Italiano",
    },
    {
        locale: "ja",
        localeString: "日本語",
    },
    {
        locale: "nl",
        localeString: "Nederlands",
    },
    {
        locale: "pt",
        localeString: "Português",
    },
    {
        locale: "ru",
        localeString: "Русский",
    },
    {
        locale: "th",
        localeString: "ภาษาไทย",
    },
];
export const namespaces = [
    "common",
    "wallet",
    "seo",
    "proposal",
    "createProposal",
    "voting",
    "audits",
    "header",
    "error",
];
const options = {
    ...i18nDefaultOptions(languages),
    detection: i18nLangDetectionConfig,
    ns: namespaces,
    defaultNS: "common",
};
export default i18next;
export const i18Init = (customBackendModule, customInitOptions) => {
    i18next
        .use(resourcesToBackend((language, namespace, callback) => {
        if (!namespaces.includes(namespace)) {
            customBackendModule(language, namespace, callback);
        }
        else {
            import(`./translations/${language}/${namespace}.json`)
                .then(({ default: resources }) => {
                callback(null, resources);
            })
                .catch((_error) => {
                // TODO: raygun
                callback(_error, null);
            });
        }
    }))
        .init(customInitOptions ? customInitOptions(options) : options);
};
//# sourceMappingURL=i18n.js.map